/**
 * Which form of a counted phrase to show.
 *
 * A phrase that carries a number comes in up to three keys: `base` (one: "1 game"), `base_few`
 * (Russian 2-4: "2 игры") and `base_plural` (the rest: "5 games", "5 игр"). Uzbek has one form
 * ("5 ta o'yin") and keeps `base` and `base_plural` identical.
 *
 *   t(pluralKey('courseAssess.games.gameCountLabel', games.length, lang), { count: games.length })
 *
 * Russian follows the CLDR rules, so 21 reads like 1 ("21 игра") and 12 like 5 ("12 игр").
 */
export function pluralKey(base, count, lang) {
  if (lang === 'ru') {
    const form = new Intl.PluralRules('ru').select(count);
    if (form === 'one') return base;
    return form === 'few' ? `${base}_few` : `${base}_plural`;
  }
  return count === 1 ? base : `${base}_plural`;
}

export default pluralKey;
